module.exports.backend = {
    apiUrl: "https://manavalue.com.ar/api",
};

module.exports.captcha = "6LeCe5orAAAAAIAy0hXgb1imelgpBkcenvuKN_2d";

module.exports.showDonations = false; // Show donations footer and link

module.exports.donationLinks = [
    {name: "Donar una tierra básica", url: "https://mpago.la/15PDyB9"},
]
